// function checkidno(obj) {
var vcity = {
  11: '北京',
  12: '天津',
  13: '河北',
  14: '山西',
  15: '内蒙古',
  21: '辽宁',
  22: '吉林',
  23: '黑龙江',
  31: '上海',
  32: '江苏',
  33: '浙江',
  34: '安徽',
  35: '福建',
  36: '江西',
  37: '山东',
  41: '河南',
  42: '湖北',
  43: '湖南',
  44: '广东',
  45: '广西',
  46: '海南',
  50: '重庆',
  51: '四川',
  52: '贵州',
  53: '云南',
  54: '西藏',
  61: '陕西',
  62: '甘肃',
  63: '青海',
  64: '宁夏',
  65: '新疆',
  71: '台湾',
  81: '香港',
  82: '澳门',
  91: '国外'
}
// Add by LiuHui at 2023-11-09 for 新版永居证兼容 begin
const checkPrcNo = function(prcNo){
  prcNo = prcNo.toUpperCase().trim();
  // 校验长度，类型
  var reg = /^[A-Z]{3}[0-9]{12}$|^9\d{16}[0-9X]$/
  if (!reg.test(prcNo)) {
    return false
  }

  if(prcNo.length == 15){
    return true;
  }

  if(prcNo.length == 18 && checkBirthday(prcNo)){
    return true;
  }

  return false
}
// Add by LiuHui at 2023-11-09 for 新版永居证兼容 end
// TODO 在 'obj' 是 'number' 时会报错
const checkCard = function (obj) {
  // 校验长度，类型
  if (isCardNo(obj) === false) {
    return false
  }
  // 检查省份
  if (checkProvince(obj) === false) {
    return false
  }
  // 校验生日
  if (checkBirthday(obj) === false) {
    return false
  }
  // 检验位的检测
  if (checkParity(obj) === false) {
    return false
  }
  return true
}
// 检查号码是否符合规范，包括长度，类型
const isCardNo = function (obj) {
  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|x|X)$)/
  if (reg.test(obj) === false) {
    return false
  }
  return true
}
// 取身份证前两位,校验省份
const checkProvince = function (obj) {
  var province = obj.substr(0, 2)
  if (vcity[province] == undefined) {
    return false
  }
  return true
}
// 检查生日是否正确
const checkBirthday = function (obj) {
  var len = obj.length
  // 身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
  if (len == '15') {
    var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/
    var arr_data = obj.match(re_fifteen)
    var year = arr_data[2]
    var month = arr_data[3]
    var day = arr_data[4]
    var birthday = new Date('19' + year + '/' + month + '/' + day)
    return verifyBirthday('19' + year, month, day, birthday)
  }
  // 身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
  if (len == '18') {
    var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)$/
    var arr_data = obj.match(re_eighteen)
    var year = arr_data[2]
    var month = arr_data[3]
    var day = arr_data[4]
    var birthday = new Date(year + '/' + month + '/' + day)
    return verifyBirthday(year, month, day, birthday)
  }
  return false
}
// 校验日期
const verifyBirthday = function (year, month, day, birthday) {
  var now = new Date()
  var now_year = now.getFullYear()
  // 年月日是否合理
  if (birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day) {
    // 判断年份的范围（3岁到100岁之间)
    var time = now_year - year
    if (time >= 0 && time <= 130) {
      return true
    }
    return false
  }
  return false
}
// 校验位的检测
const checkParity = function (obj) {
  // 15位转18位
  obj = changeFivteenToEighteen(obj)
  var len = obj.length
  if (len == '18') {
    var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2)
    var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2')
    var cardTemp = 0, i, valnum
    for (i = 0; i < 17; i++) {
      cardTemp += obj.substr(i, 1) * arrInt[i]
    }
    valnum = arrCh[cardTemp % 11]
    if (valnum == obj.substr(17, 1)) {
      return true
    }
    return false
  }
  return false
}
// 15位转18位身份证号
const changeFivteenToEighteen = function (obj) {
  if (obj.length == '15') {
    var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2)
    var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2')
    var cardTemp = 0, i
    obj = obj.substr(0, 6) + '19' + obj.substr(6, obj.length - 6)
    for (i = 0; i < 17; i++) {
      cardTemp += obj.substr(i, 1) * arrInt[i]
    }
    obj += arrCh[cardTemp % 11]
    return obj
  }
  return obj
}

const getAge = function (identityCard) {
  var len = (identityCard + '').length
  if (len === 0) {
    return 0;
  } else {
    if ((len !== 15) && (len !== 18)) // 身份证号码只能为15位或18位其它不合法
    {
      return 0;
    }
  }
  var strBirthday = '';
  if (len === 18) // 处理18位的身份证号码从号码中得到生日和性别代码
  {
    strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
  }
  if (len === 15) {
    strBirthday = '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
  }
  // 时间字符串里，必须是“/”
  var birthDate = new Date(strBirthday)
  var nowDateTime = new Date()
  var age = nowDateTime.getFullYear() - birthDate.getFullYear()
  // 再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

//2020-03-08 年龄限制问题修复 begin
function getAgeByPlayDate(identityCard, playDay) {
  var len = (identityCard + "").length;

  if (len == 0) {
      return 0;
  } else {
      if ((len != 15) && (len != 18))//身份证号码只能为15位或18位其它不合法
      {
          return 0;
      }
  }

  var strBirthday = "";
  if (len == 18)//处理18位的身份证号码从号码中得到生日和性别代码
  {
      strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
  }
  if (len == 15) {
      strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
  }
  //时间字符串里，必须是“/”
  var birthDate = new Date(strBirthday);
  var nowDateTime = new Date(playDay);
  var age = nowDateTime.getFullYear() - birthDate.getFullYear();
  //2020-03-08  年龄限制问题修改 begin
  // 严格限制 60 岁老头子 begin
  // if (age >= 60) {
  //     return age;
  // }
  // 严格限制 60 岁老头子 end
  //2020-03-08  年龄限制问题修改 end
  //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  //2020-03-08  年龄限制问题修改 begin
  // if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
  //     age--;
  // }
  var nowDateTimeMD = nowDateTime.getMonth() + "" + (nowDateTime.getDate() < 10 ? "0" + nowDateTime.getDate() : nowDateTime.getDate());
  var birthDateMD = birthDate.getMonth() + "" + (birthDate.getDate() < 10 ? "0" + birthDate.getDate() : birthDate.getDate());
  //Mod by LiuHui at 20210203 for 年龄限制 begin
  //if (parseInt(nowDateTimeMD) - parseInt(birthDateMD) > 0) {
    if (age != 60 && parseInt(nowDateTimeMD) - parseInt(birthDateMD) >= 0) {
      //Mod by LiuHui at 20210203 for 年龄限制 end
      if (parseInt(nowDateTimeMD) - parseInt(birthDateMD) == 0) {
        return age - 1;
      } else {
        return age;
      }
      
  // 严格限制 60 岁老头子 begin
  // } else {
  //     return age - 1;
  // }

  } else {
      if (age == 60 && parseInt(nowDateTimeMD) - parseInt(birthDateMD) >= 0){
          return 60
      }else {
          return age - 1;
      }
  }
// 严格限制 60 岁老头子 begin
//2020-03-08  年龄限制问题修改 end
  return age;
}
//2020-03-08 年龄限制问题修复 end

// 2020-03-08 年龄限制问题修复 begin

// const getAgeByPlayDate = function (identityCard, playDay) {
//   var len = (identityCard + '').length

//   if (len === 0) {
//     return 0
//   } else {
//     if ((len !== 15) && (len !== 18)) // 身份证号码只能为15位或18位其它不合法
//     {
//       return 0
//     }
//   }

//   var strBirthday = ''
//   if (len === 18) // 处理18位的身份证号码从号码中得到生日和性别代码
//   {
//     strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
//   }
//   if (len === 15) {
//     strBirthday = '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
//   }
//   // 时间字符串里，必须是“/”
//   var birthDate = new Date(strBirthday)
//   var nowDateTime = new Date(playDay)
//   var age = nowDateTime.getFullYear() - birthDate.getFullYear()
//   // 2020-03-08  年龄限制问题修改 begin
//   if (age >= 60) {
//     return age
//   }
//   // 2020-03-08  年龄限制问题修改 end
//   // 再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
//   // 2020-03-08  年龄限制问题修改 begin
//   // if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
//   //     age--;
//   // }
//   var nowDateTimeMD = nowDateTime.getMonth() + '' + (nowDateTime.getDate() < 10 ? '0' + nowDateTime.getDate() : nowDateTime.getDate())
//   var birthDateMD = birthDate.getMonth() + '' + (birthDate.getDate() < 10 ? '0' + birthDate.getDate() : birthDate.getDate())
//   if (parseInt(nowDateTimeMD) - parseInt(birthDateMD) > 0) {
//     return age
//   } else {
//     return age - 1
//   }
//   // 2020-03-08  年龄限制问题修改 end
//   return age
// }
//2020-03-08 年龄限制问题修复 end

// (function (global, factory) {
//   if (global.RegexValidate) {
//     console.error('RegexValidate exists in the global')
//     return;
//   }
//   factory(global.RegexValidate = {})
// })(this, function (exports) {
  'use strict'
  var REGEXS = {
    companyName : /^[a-zA-Z0-9\.\s\,\(\)\（\）\u4e00-\u9fff]{2,50}$/,
    taxId: /^[0-9A-Z]{6,20}$/,
    fullName: /^[\u4e00-\u9fa5a-zA-Z]+(·[\u4E00-\u9FA5a-zA-Z]+)*$/,
    cnName: /^[\u4e00-\u9fa5]+$/,
    mobile: /^1[3456789]\d{9}$/,//手机号 /^1[0-9]{10}$/
    phone: /^(0\d{2,4}-\d{7,8})$/,//座机号
    email: /^([A-Za-z0-9_+-.])+@([A-Za-z0-9\-.])+\.([A-Za-z]{2,22})$/,
    // email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
       // hkmTPassport: /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/, // 加入台湾证件后，整个港澳台证件校验放宽
    hkmTPassport: /^[a-zA-Z0-9]{5,15}$/,
    prc: /^[0-9]{1,15}$|^[A-Z]{1,15}$|^[a-z]{1,15}$|^[a-zA-Z0-9]{1,15}$/,
    passport1: /^[a-zA-Z]{5,15}$/,
    passport2: /^[a-zA-Z0-9]{5,15}$/,
    guideNo : /^[a-zA-Z0-9-_]{8,20}$/,
    accountName: /^[a-zA-Z0-9\.\s·•\,\(\)\（\）\u4e00-\u9fff]{2,50}$/,
    accountNo: /^[0-9]{1,30}$/
  }

const isNumOrStr = function(val) {
  var type = typeof val
  return type === 'string' || type === 'number'
};
const isCompanyName = function(val) {
  return isNumOrStr(val) && REGEXS.companyName.test(val)
};
const isCnName = function(val) {
  return isNumOrStr(val) && REGEXS.cnName.test(val)
};
const isTaxId = function(val) {
  return isNumOrStr(val) && REGEXS.taxId.test(val)
};
const isFullName = function(val) {
  return isNumOrStr(val) && REGEXS.fullName.test(val) && val.length <= 30
};
const isMobile = function (val) {//手机号码
  return isNumOrStr(val) && REGEXS.mobile.test(val)
};
const isPhone = function (val) {//座机
  return isNumOrStr(val) && REGEXS.phone.test(val)
};
const isPhoneOrMobile = function (val) {//手机号码、或者座机
  return isNumOrStr(val) && (REGEXS.mobile.test(val) || REGEXS.phone.test(val))
};
const isEmail = function (val) {
  return isNumOrStr(val) && REGEXS.email.test(val)
};
const isIDCard = function (val) {
  return isNumOrStr(val) && checkCard(val)
};
const isHKMTPassport = function (val) {
  return isNumOrStr(val) && REGEXS.hkmTPassport.test(val)
};
const isPRC = function (val) {
  // Mod by LiuHui at 2023-11-09 for 新版永居证兼容 begin
  // return isNumOrStr(val) && REGEXS.prc.test(val)
  return isNumOrStr(val) && checkPrcNo(val)
  // Mod by LiuHui at 2023-11-09 for 新版永居证兼容 end
};
const isPassport = function (val) {
  return isNumOrStr(val) && (REGEXS.passport1.test(val) || REGEXS.passport2.test(val))
};
const isGuideNo = function (val) {
  return isNumOrStr(val) && REGEXS.guideNo.test(val)
};
const isOtherCer = function (str) {
  if (str === '' || str.trim() === '' || str.length > 30) {
    return false
  }
  return true
};
const isNotEmpty = function (str) {
  if (str === '' || str.trim() === '') {
    return false
  }
  return true
};

const isAccountName = function (val) {
  return isNumOrStr(val) && REGEXS.accountName.test(val)
};

const isAccountNo = function (val) {
  return isNumOrStr(val) && REGEXS.accountNo.test(val)
};

  // exports.isCompanyName = isCompanyName
  // exports.isTaxId = isTaxId
  // exports.isFullName = isFullName
  // exports.isMobile = isMobile
  // exports.isPhone = isPhone
  // exports.isPhoneOrMobile = isPhoneOrMobile
  // exports.isEmail = isEmail
  // exports.isIDCard = isIDCard
  // exports.isHKMTPassport = isHKMTPassport
  // exports.isPassport = isPassport
  // exports.isGuideNo = isGuideNo
  // exports.isOtherCer = isOtherCer
  // exports.isNotEmpty = isNotEmpty
// });

export {
  isCompanyName,
  isCnName,
  isTaxId,
  isFullName,
  isMobile,
  isPhone,
  isPhoneOrMobile,
  isEmail,
  isIDCard,
  isHKMTPassport,
  isPRC,
  isPassport,
  isGuideNo,
  isOtherCer,
  isNotEmpty,
  getAgeByPlayDate,
  isAccountName,
  isAccountNo
}
